// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventPage_wrapper_39o8j"};